/**
 * @ngdoc directive
 * @name cbl.cartadebitoint.wa.directive:cdintDatiAml
 * @restrict E
 * @description Componente per la visualizzazione di una pratica di credito
 *              assicurativo
 */
(function () {
  'use strict';
  var CdintDatiAmlCtrl = function (
    $q,
    $http,
    $scope,
    $state,
    $stateParams,
    $cacheFactory,
    CONSTANTS,
    labelSrvc,
    domainSrvc,
    messaggiFctr,
    propostaCartaDebitoIntSrvc,
    questionarioKycService,
    $uibModal,
    $element
  ) {
    this.$http = $http;
    this.$state = $state;
    this.$stateParams = $stateParams;
    this.$cacheFactory = $cacheFactory;
    this.domainSrvc = domainSrvc;
    this.messaggiFctr = messaggiFctr;
    this.propostaCartaDebitoIntSrvc = propostaCartaDebitoIntSrvc;
    this.CONSTANTS = CONSTANTS;
    this.$uibModal = $uibModal;
    this.questionarioKycService = questionarioKycService;
    $scope.msg = labelSrvc.getLabel;

    /**
     * Indica se il caricamento delle labels è andato a buon fine
     */
    this.labelsPronte = false;

    /**
     * Riferimento allo spinner globale
     */
    this.spinner = this.propostaCartaDebitoIntSrvc.spinner;

    /**
     * ID del conto corrente
     */
    this.idConto = null;

    /**
     * Dati anagrafici legati alla pratica
     */
    this.datiAnagrafici = null;

    /**
     * Riferimento interno al controller per recuperare i valori nelle funzioni
     */
    var self = this;

    /**
     * Implementazione nel service della funzione di abilitazione salvataggio stato pratica
     */
    this.propostaCartaDebitoIntSrvc.salvaAbilitato = function () {
      return true;
    };

    /**
     * Implementazione nel service della funzione di abilitazione proseguimento iter pratica
     */
    this.propostaCartaDebitoIntSrvc.proseguiAbilitato = function () {
      return true;
    };

    /**
     * Implementazione nel service della funzione di visualizzazione bottone prosegui
     */
    this.propostaCartaDebitoIntSrvc.proseguiVisibile = function () {
      return true;
    };

    // PER IL MOMENTO NON UTILIZZATO
    //
    // Il pulsante Prosegui è sempre abilitato (https://youtrack.cabel.net/issue/CDICDDI-189)
    // /**
    //  * Verifica se i dati inseriti nel form sono validi
    //  */
    // this.formValido = function () {
    //   // recupero tutti gli elementi select enabled selezionati.
    //   var kycRapporto = angular.element('#kyc-rapporto :enabled option:selected', $element);

    //   // se non ho ancora caricato il form passo.
    //   if (kycRapporto && kycRapporto.length == 0) return false;
    //   var okForm = 0; // tutto ok

    //   // scorro tutto e riquadro i dati obbligatori
    //   // + check per disabilita form.
    //   kycRapporto.each(function (index) {
    //     var value = $(this).text().trim();
    //     if (!value) {
    //       $(this).focus();
    //       $(this).parent().addClass('border border-danger');
    //       okForm += 1;
    //     } else $(this).parent().removeClass('border border-danger');
    //   });

    //   return okForm === 0;
    // };

    this.propostaCartaDebitoIntSrvc.proseguiAml = function () {
      return self.questionarioKycService.stepForward();
    };

    this.propostaCartaDebitoIntSrvc.salvaAml = function () {
      return self.questionarioKycService.saveCurrentFase();
    };

    /**
     *  Funzione richiamata all'avvio del controller
     */
    this.init = function () {
      labelSrvc.labelsPronte.then(function () {
        self.labelsPronte = true;

        self.propostaCartaDebitoIntSrvc.spinner.showSpinner++;
        self.propostaCartaDebitoIntSrvc
          .promiseRecuperaDatiConto(self.propostaCartaDebitoIntSrvc.datiPratica.idPratica)
          .then(function (response) {
            if (response.data && response.data.result) {
              self.idConto = response.data.result.idPratica;
            }
          })
          .finally(function () {
            if (self.propostaCartaDebitoIntSrvc.spinner.showSpinner > 0) {
              self.propostaCartaDebitoIntSrvc.spinner.showSpinner--;
            }
          });
      });
    };

    self.init();
  };

  CdintDatiAmlCtrl.$inject = [
    '$q',
    '$http',
    '$scope',
    '$state',
    '$stateParams',
    '$cacheFactory',
    'CDINT_CONSTANTS',
    'CdintLabelSrvc',
    'CdintDomainSrvc',
    'CdintMessaggiFctr',
    'CdintPropostaCartaDebitoIntSrvc',
    'QuestionarioKycService',
    '$uibModal',
    '$element'
  ];

  var TemplateUrl = function (CONSTANTS) {
    return (
      CONSTANTS.BASE_ROOT + CONSTANTS.COMPONENTS_PATH + 'cdintPropostaCartaDebitoInt/cdintDatiAml/cdintDatiAml.html'
    );
  };

  TemplateUrl.$inject = ['CDINT_CONSTANTS'];

  var CdintDatiAmlComponent = {
    controller: CdintDatiAmlCtrl,
    controllerAs: 'cdintDatiAmlCtrl',
    templateUrl: TemplateUrl
  };

  angular.module('cbl.cartadebitoint.wa').component('cdintDatiAml', CdintDatiAmlComponent);
})();



//////////////////
// WEBPACK FOOTER
// ./app/components/cdintPropostaCartaDebitoInt/cdintDatiAml/cdintDatiAml.cmpt.js
// module id = 7
// module chunks = 0